import { createLabel } from './createLabel';

export const TopLabel = createLabel({
  title: 'Топ',
  bgColor: 'silver',
});

export const TopBetLabel = createLabel({
  title: 'Топ + Ставка',
  bgColor: 'silver',
});

export const PremiumLabel = createLabel({
  title: 'Премиум',
  bgColor: 'orange',
});

export const StandardLabel = createLabel({
  title: 'Стандарт',
  bgColor: 'gray',
});
